(ns cuerdas.vendor.xregexp
  (:require ["xregexp" :as xre]))

(js/goog.exportSymbol "XRegExp" xre)
